<template>
    <div class="legal-page">
        <div class="content">
            <h1>{{$t('LegalDisclamerLink')}}</h1>
            <p v-html="$t(routeToUse === 'mstar' ? 'MStarLegalDisclaimer' : 'LegalDisclaimer')" />
        </div>
        <router-link
            id="qa-button-back"
            :to="getBackLink"
            class="mds-button mds-button--secondary">
            {{ $t('Back') }}
        </router-link>
    </div>
</template>

<script>

export default {
    data () {
        return {
            routeToUse: this.$router.currentRoute.path.toLowerCase().includes('morningstarlifetimeindexfunds') ? 'mstar' : ''
        };
    },
    computed: {
        getBackLink() {
            return this.routeToUse === 'mstar' ? '/MorningstarLifetimeIndexFunds' : '/'
        }
    },
    watch: {
        $route(to, from) {
            this.routeToUse = to.path.toLowerCase().includes('morningstarlifetimeindexfunds') ? 'mstar' : '';
        }
    }
};
</script>

<style lang="scss" scoped>
.legal-page {
    text-align: center;
    padding-bottom: $mds-space-4-x;
    .content {
        max-width: 660px;
        padding: $mds-space-4-x;

        h1 {
            text-align: center;
        }

        p {
            text-align: left;
            @include mds-body-text-l();
            color: $mds-text-color-primary-default;
        }
    }

    .mds-button {
        &:hover {
            color: $mds-color-white;
        }
    }

    @media #{$bp-desktop} {
        margin: 0 auto;
        padding-bottom: $mds-space-inset-8-x;
    }
}
</style>



// WEBPACK FOOTER //
// src/routes/LegalPage.vue